import {
  U21Button,
  U21InfoItem,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';
import { formatDatetime } from 'app/shared/utils/date';
import { IconShieldCheck } from '@u21/tabler-icons';
import { useSelector } from 'react-redux';
import { selectHasOverrideRiskRatingsPermission } from 'app/modules/session/selectors';
import { EntityLatestOverrideRiskScore } from 'app/modules/riskScore/models';

interface Props {
  latestRiskScore: EntityLatestOverrideRiskScore;
  onClearOverride: () => void;
  readOnly?: boolean;
}

export const RiskScoreOverrideDetails = (props: Props) => {
  const { latestRiskScore, onClearOverride, readOnly } = props;

  const hasOverridePermission = useSelector(
    selectHasOverrideRiskRatingsPermission,
  );

  return (
    <U21Spacer>
      <U21InfoItem label="Score">
        <U21Typography variant="body2">
          <s>{Math.round(latestRiskScore.override.model_score)}</s>&nbsp;→&nbsp;
          <b>{Math.round(latestRiskScore.score)}</b>
        </U21Typography>
      </U21InfoItem>
      <U21InfoItem label="Overridden by">
        {latestRiskScore.override.updated_by.full_name}
      </U21InfoItem>
      <U21InfoItem label="Overridden at">
        {formatDatetime(latestRiskScore.override.updated_at)}
      </U21InfoItem>
      <U21InfoItem label="Expires at">
        {formatDatetime(latestRiskScore.override.expires_at)}
      </U21InfoItem>
      <U21InfoItem
        label="Reason"
        valueProps={{ breakWord: true, ellipsis: false }}
      >
        {latestRiskScore.override.comment}
      </U21InfoItem>
      {!readOnly && hasOverridePermission && (
        <div>
          <U21Button
            startIcon={<IconShieldCheck />}
            onClick={onClearOverride}
            size="small"
            color="error"
          >
            Clear Override
          </U21Button>
        </div>
      )}
    </U21Spacer>
  );
};
